import * as gzAppBroker from './app-broker.service';

export default angular.module('gazelle.components.appBroker', [
  'ngMaterial'
])
  .service(gzAppBroker.name, gzAppBroker.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/app-broker/app-broker.module.js